export default __webpack_public_path__ + "static/media/Nunito-SemiBoldItalic.2360e4ec.woff2";